import { Outlet } from 'react-router-dom';

/**
 * PublicGuard component
 * Allows access to all users (authenticated or unauthenticated)
 * Can be used for routes that should be visible to everyone (e.g., public products page)
 */
export const PublicGuard = () => {
    return <Outlet />;
};
